import { FormControl, InputLabel } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import type { ChangeEventHandler, ReactElement } from 'react';

interface IFileInputFieldProps {
  name: string;
  label?: ReactElement | string;
  isRequired?: boolean;
  onChange?: ChangeEventHandler;
  accept?: string;
  inputRef?: (element: HTMLInputElement | null) => void;
  isMultiple?: boolean;
}

export const FileInputField = (props: IFileInputFieldProps) => {
  const { name, label, isRequired, onChange, accept, inputRef, isMultiple }: IFileInputFieldProps = props;

  const { getTestIdProps } = useTestId();

  let inputLabel = null;

  if (label) {
    inputLabel = (
      <InputLabel
        {...getTestIdProps(`${name}-file-input-label`)}
        htmlFor={name}
      >
        {label}
      </InputLabel>
    );
  }

  return (
    <FormControl
      fullWidth
      required={isRequired}
      style={{ display: 'none' }}
    >
      {inputLabel}
      <input
        ref={inputRef}
        name={name}
        id={name}
        type="file"
        accept={accept}
        multiple={isMultiple}
        onChange={onChange}
      />
    </FormControl>
  );
};
